import styled, { css } from 'styled-components'
import { HTMLAttributes, CSSProperties, ReactNode, MouseEvent } from 'react'

export interface FlexRowProps {
  display?: CSSProperties['display']
  flex?: CSSProperties['flex']
  justifyContent?: CSSProperties['justifyContent']
  flexDirection?: CSSProperties['flexDirection']
  noMargin?: boolean
  padding?: CSSProperties['padding']
  gap?: CSSProperties['gap']
  autoWidth?: boolean
  wrap?: boolean
  alignItems?: CSSProperties['alignItems']
  alignContent?: CSSProperties['alignContent']
  divided?: boolean
  breakOnMobile?: boolean
  children?: ReactNode
  style?: HTMLAttributes<HTMLDivElement>['style']
  onClick?: (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

interface FlexRowSectionProps {
  display?: CSSProperties['display']
  flex?: CSSProperties['flex']
  alignItems?: CSSProperties['alignItems']
  flexDirection?: CSSProperties['flexDirection']
  justifyContent?: CSSProperties['justifyContent']
  gap?: CSSProperties['gap']
  breakOnMobile?: boolean
  style?: HTMLAttributes<HTMLDivElement>['style']
}

export const StyledFlexRow = styled.div<FlexRowProps>`
  display: ${props => props.display || 'inline-flex'} !important;
  position: relative;
  flex: ${props => props.flex || 'auto'};
  justify-content: ${props => props.justifyContent || 'space-between'};
  flex-direction: ${props => props.flexDirection || 'row'};
  margin: ${props => (props.noMargin ? 0 : '0 0 1rem 0')};
  padding: ${props => props.padding ?? '0'};
  gap: ${props => props.gap ?? '0'};
  width: ${props => (props.autoWidth ? 'auto' : '100%')};
  flex-wrap: ${props => (props.wrap ? 'wrap' : 'nowrap')};
  align-items: ${props => props.alignItems || 'flex-start'};
  align-content: ${props => props.alignContent || 'flex-start'};

  > div {
    ${props => props.divided && 'margin-right: 1em'};

    :last-child {
      margin-right: 0;
    }
  }

  ${({ breakOnMobile, theme }) =>
    breakOnMobile &&
    css`
      ${theme.mediaQueries.mobile} {
        justify-content: flex-start;

        &,
        > div {
          flex-wrap: wrap;
        }

        > * {
          margin-bottom: 0.5em;
        }
      }
    `}
`

export const StyledSection = styled.div<FlexRowSectionProps>`
  display: ${props => props.display || 'inline-flex'} !important;
  flex: ${props => props.flex || 'auto'};
  align-items: ${props => props.alignItems || 'center'};
  flex-direction: ${props => props.flexDirection || 'row'};
  gap: ${props => props.gap ?? '0'};
  ${props =>
    props.justifyContent ? `justify-content: ${props.justifyContent}` : ''};

  ${({ breakOnMobile, theme }) =>
    breakOnMobile &&
    css`
      ${theme.mediaQueries.mobile} {
        justify-content: flex-start !important;

        > *:not(:last-child) {
          margin-bottom: 0.5em !important;
        }
      }
    `}
`
